import { Button, Select, Switch, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../atoms/CustomIcons";
import React, { useState } from "react";
import { useAppDispatch } from "../../../../../config/hooks";
import { useNavigate } from "react-router-dom";
import { removeSubcontractListData } from "../../../ducks/actions";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      type: undefined | string;
      status: undefined | string;
      state: undefined;
      city: undefined;
      onboarding_complete_date: string[] | undefined;
      last_user_activity: string[] | undefined;
      search_text: undefined | string;
    }>
  >;
  filters: {
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    onboarding_complete_date: string[] | undefined;
    last_user_activity: string[] | undefined;
    search_text: undefined | string;
  };
  archived: boolean;
  companyId: string;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters, archived, isArchived, companyId } = props;
  const dispatch = useAppDispatch();
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();
  // const clientManagerList = useAppSelector(
  //   (state) => state?.company?.companyClientManager
  // );

  const onChange = (checked: boolean) => {
    dispatch(removeSubcontractListData());
    isArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      type: undefined,
      status: undefined,
      state: undefined,
      city: undefined,
      onboarding_complete_date: undefined,
      last_user_activity: undefined,
      search_text: undefined,
    });
    isArchived(false);
  };

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterTabsButton">
          <Button onClick={() => navigate(`/crews/${companyId}`)} type="text">
            Crews
          </Button>
          <Button onClick={() => navigate(`/subs/${companyId}`)} type="primary">
            Subs
          </Button>
        </div>
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search subcontractors"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              archived && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Tooltip title="Export the list of subcontractors">
            <Button icon={<DownloadIcon />} />
          </Tooltip>
        </div>
        {/* <div className="filterBox">
          <div className="switchBox">
            <Switch onChange={onChange} checked={archived} />
            {archived ? "Mine only" : "Mine only"}
          </div>
        </div> */}
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            {/* <div className="filterBox">
              <Tooltip title="Type" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, type: value }))
                  }
                  value={filters?.type}
                  placeholder="Type"
                  options={[
                    {
                      value: "company",
                      label: "Company",
                    },
                    {
                      value: "individual",
                      label: "Individual",
                    },
                  ]}
                />
              </Tooltip>
            </div> */}
            <div className="filterBox">
              <Tooltip title="Crew leader" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Crew leader"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Service lines" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Service lines"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Crew member" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Crew member"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Production manager" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Production manager"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Tags" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Tags"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Labor revenue (YTD)" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Labor revenue (YTD)"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Labor GM (YTD)" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "180px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Labor GM (YTD)"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                {archived ? "Hide archived" : "Show archived"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={!filters.type && !filters.status}
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
